import ArtColaboracao from 'assets/img/reconhecimento/comportamento-colaboracao.png';
import ArtFoco from 'assets/img/reconhecimento/comportamento-foco.png';
import ArtInovacao from 'assets/img/reconhecimento/comportamento-inovacao.png';
import ArtLideranca from 'assets/img/reconhecimento/comportamento-lideranca.png';
import ArtProtagonismo from 'assets/img/reconhecimento/comportamento-resolutividade.png';
import ArtMandou from 'assets/img/reconhecimento/tipo-mandou.png';
import ArtUau from 'assets/img/reconhecimento/tipo-uau.png';
import ArtValeu from 'assets/img/reconhecimento/tipo-valeu.png';

import { BehaviorKey } from '../recognition';
import { CoinKey } from '../recognition-points';

export const BEHAVIOR_ART: Record<BehaviorKey, string> = {
  colaboracao: ArtColaboracao,
  foco: ArtFoco,
  inovacao: ArtInovacao,
  resolutividade: ArtProtagonismo,
  lideranca: ArtLideranca,
};

export const COIN_ART: Record<CoinKey, string> = {
  valeu: ArtValeu,
  mandou: ArtMandou,
  uau: ArtUau,
};
